import { z } from 'zod';

export const ChangePasswordSchema = 
z.object({
	currentPassword: z.string().min(1, 'errlogin_enter_pw'),
	newPassword: z.string().min(1, 'errlogin_enter_pw').min(6, 'lbl_RegistPasswordlimit').max(10, 'lbl_RegistPasswordlimit').regex(/^[a-zA-Z0-9]+$/, 'lbl_RegistPasswordWronformat'),
	confirmPassword: z.string().min(1, 'errlogin_enter_pw'),
}).refine((data) => data.newPassword === data.confirmPassword, {
	message: 'ColossusBetPrizeErrorMessage2',
	path: ['confirmPassword']
}).refine((data) => data.currentPassword !== data.newPassword, {
	message: 'change_pwd_the_same',
	path: ['newPassword']
});


export type SignUpInputs = z.infer<typeof ChangePasswordSchema>;